
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RouteMeta } from "vue-router/types/router";

declare type breadcrumb = { name?: string; link?: string; onClick?: () => void };

@Component
export default class Breadcrumb extends Vue {
  // 覆寫整份麵包屑清單（例如答案頁要把上層分類變成可點擊、並附加當前問題文字）。
  // 不傳時預設用 route.meta.breadcrumb。
  @Prop({ default: null }) items!: breadcrumb[] | null;

  //data
  breadcrumbList: breadcrumb[] = [{ name: "" }];

  //hook
  mounted(): void {
    this.updateBreadcrumbList();
  }

  //computed
  get displayList(): breadcrumb[] {
    return this.items || this.breadcrumbList;
  }

  //methods
  isClickable(item: breadcrumb): boolean {
    return !!(item.link || item.onClick);
  }
  routeTo(index: number): void {
    const target = this.displayList[index];
    if (!target) return;
    if (target.onClick) target.onClick();
    else if (target.link) this.$router.push(target.link);
  }
  updateBreadcrumbList(): void {
    this.breadcrumbList = (this.$route.meta as RouteMeta).breadcrumb as breadcrumb[];
  }

  // watch
  @Watch("$route")
  watchRouter():void {
    this.updateBreadcrumbList();
  }
}
